import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useLocalizeProperty } from '@mews/framework';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';

export const useProductNames = (productIds: string[]) => {
    const enterpriseId = useCurrentEnterpriseId();
    const localizeProperty = useLocalizeProperty();

    const { data } = useRepositorySuspenseQuery(
        'products',
        'getAll',
        {
            enterpriseIds: [enterpriseId],
            productIds,
        },
        {
            select: ({ products }) => (products ? products.map((product) => localizeProperty(product.names)) : null),
        }
    );

    return data;
};
